import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ palette }) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1.2rem',

      overflow: 'hidden auto',

      width: 'max(100%, calc((100vw + 127.6rem) / 2))',

      '& > section': {
        width: 'max-content',
        zIndex: 1,
      },
    },

    emptyContainer: {
      maxWidth: '33.5rem',

      marginTop: '12rem',
      marginLeft: '54rem',

      textAlign: 'center',
      zIndex: 5,

      '& > p': {
        fontSize: '1.2rem',
        marginTop: '0.4rem',
      },
    },

    previousDiagnosisContainer: {
      marginTop: '2.4rem',
      paddingBottom: '1.4rem',
      borderBottom: '1px solid #C3C3C3',
    },

    nextDiagnosisContainer: {
      marginTop: '1.6rem',
    },

    fetchMoreButton: {
      paddingInline: '0.6rem 2rem',
      margin: 0,
      width: 'fit-content',
      height: '3.2rem',

      fontSize: '1.2rem',
      letterSpacing: 0.5,

      gap: '0.8rem',

      border: `1px solid ${palette.secondary.main}`,

      '& > svg': {
        fontSize: '1.6rem',
      },

      '&:not(:disabled):hover': {
        borderColor: palette.text.primary,
      },

      '& .MuiTouchRipple-root': {
        color: palette.text.primary,
      },
    },

    diagnosisItem: {
      display: 'flex',
      minHeight: '13.4rem',
      borderBottom: '1px solid #C3C3C3',

      marginTop: '1.4rem',
    },
    description: {
      display: 'flex',
      flexDirection: 'column',
      gridGap: '0.4rem',

      minWidth: '19.6rem',
      maxWidth: '19.6rem',

      '& strong, & h6': {
        fontWeight: 600,
      },

      '& p': {
        fontSize: '1.2rem',
      },
    },

    activity: {
      display: 'block',
      height: 24,
      padding: '0.2rem 0.4rem',

      borderWidth: '1px',
      borderStyle: 'solid',
      borderRadius: '5px',

      '& > div': {
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',

        '& > svg': {
          fontSize: '1.6rem',
        },

        '& > span': {
          fontSize: '1.6rem',

          '&.rotate': {
            transform: 'rotate(180deg)',
          },
        },

        '& > p': {
          fontSize: '1.2rem',
          textWrap: 'nowrap',
        },
      },
    },
  }),
)
